import { Padding, ProgressChart } from '../../../../components'

type PushConfirmationBodyProps = {
    confirmationMessage: string
    inProgressMessage: string
    percentage?: number
} 

export default function PushConfirmationBody({
    confirmationMessage,
    inProgressMessage,
    percentage,
}: PushConfirmationBodyProps) {
    const isWorking = typeof percentage ===  'number'

    if (isWorking) {
        return (
            <>
                <Padding bottom>
                    {inProgressMessage}
                </Padding>
                <ProgressChart size="xs" value={percentage} withPercentage />
            </>
        )
    }

    return (
        <>
            {confirmationMessage}
        </>
    )
}